import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'

import { IServiceObjectGroup } from './IServiceObjectGroup';
import { IapObjectGroup } from '../domain/iapObjectGroup';
import type { IObjectGroupRepository } from '../domain/IObjectGroupRepository';



@injectable()
export class ObjectGroupService implements IServiceObjectGroup {
  private readonly repo: IObjectGroupRepository

  public constructor (@inject(TYPES.OBJECTGROUP_DIRECTIVE_REPOSITORY) _repo: IObjectGroupRepository) {
    this.repo = _repo
  }

  async update (data: IapObjectGroup): (Promise<boolean>) {
    return await this.repo.update(data);
  }

  async add (data: IapObjectGroup): (Promise<boolean>) {
    return await this.repo.add(data);
  }

  async getAll(maxregs: number | undefined) :Promise<IapObjectGroup[]> {
    return await this.repo.getAll(maxregs)
  }

  async getById(id: number) :Promise<IapObjectGroup> {
    return await this.repo.getById(id)
  }

  async grantAccessToObjectGroup(objectId: number, objectGroup: IapObjectGroup, objectType: string, applicationId: number, applicationVersion: number) :Promise<Boolean> {
    return await this.repo.grantAccessToObjectGroup(objectId, objectGroup, objectType, applicationId, applicationVersion)
  }
}
